import React from "react";
import Header from "../../components/home/header/Header";
import MyProfile from "../../components/about/MyProfile";
import Footer from "../../components/footer/Footer";

const About = () => {
  return (
    <>
      <Header />
      <MyProfile />
      <Footer />
    </>
  );
};

export default About;
